import { Flex, Box, Text } from '@chakra-ui/react'
import { brand } from '../../../theme'
import { useChartTheme } from '../../../hooks/useChartTheme'
import type { PeriodFilter } from '../../../data/mockEstadisticas'

const periods: { value: PeriodFilter; label: string }[] = [
  { value: '7d', label: '7D' },
  { value: '30d', label: '30D' },
  { value: '90d', label: '90D' },
  { value: '12m', label: '12M' },
]

interface PeriodSelectorProps {
  selected: PeriodFilter
  onChange: (period: PeriodFilter) => void
}

export default function PeriodSelector({ selected, onChange }: PeriodSelectorProps) {
  const { colors } = useChartTheme()

  return (
    <Flex gap={1} bg="#efe8dd" p={1} borderRadius="xl">
      {periods.map((p) => {
        const isActive = p.value === selected
        return (
          <Box
            key={p.value}
            as="button"
            px={3}
            py={1.5}
            borderRadius="md"
            fontSize="xs"
            fontWeight="600"
            cursor="pointer"
            transition="all 0.2s"
            bg={isActive ? brand.green : 'transparent'}
            color={isActive ? 'white' : colors.textMuted}
            _hover={isActive ? {} : { bg: '#e8dfd1' }}
            onClick={() => onChange(p.value)}
          >
            <Text>{p.label}</Text>
          </Box>
        )
      })}
    </Flex>
  )
}
